var _rect, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRivetBackground1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 311,
    viewBox: "0 0 403 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 310,
    fill: "#45293F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_665",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 403,
    height: 310
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 403,
    height: 310,
    fill: "#45293F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.82 201.309C258.246 183.735 258.246 155.243 275.82 137.669C293.393 120.095 321.886 120.095 339.459 137.669L577.047 375.257L513.408 438.897L275.82 201.309Z",
    fill: "#F26B49"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 246L331 310.1H402.83V274.5L360 246Z",
    fill: "#F26B49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivetBackground1);
export default __webpack_public_path__ + "static/media/rivetBackground_1.7b8cf5ed262744438d68996ee486335e.svg";
export { ForwardRef as ReactComponent };